/**
 * This polyfills the Promise.withResolvers method needed for the PDF.js library.
 *
 * Currently the Dash ESV uses an unsupported version of Chromium, which is why
 * we need to polyfill this method.
 */
if (typeof Promise.withResolvers === "undefined") {
  // @ts-expect-error This does not exist outside of polyfill which this is doing
  Promise.withResolvers = function () {
    let resolve, reject;

    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
}
